export const T = {
  en_GB: {
    droppedFundsWarning: "will be removed at the bank — no matching product:",
    unlinkedGroup: "Not linked to a goal",
    agreement: "Agreement",
    account: "Account",
    carriesMandate: (name: string) => `Carries mandate ${name}`,
  },
  nb_NO: {
    droppedFundsWarning: "fjernes hos banken — mangler produkt:",
    unlinkedGroup: "Ikke knyttet til et mål",
    agreement: "Avtale",
    account: "Konto",
    carriesMandate: (name: string) => `Bærer mandat ${name}`,
  },
} as const;
